module.exports = __webpack_public_path__ + "img/7.295bca4a.png";